import type { RouteObject } from "react-router"
import AddPermissionPage from "@/domains/permissions/pages/AddPermissionPage"
import { UnauthorizedPage } from "@/domains/unauthorized/pages/UnauthorizedPage/UnauthorizedPage"
import { ADMIN_PATH } from "@/shared/constants/routePaths"
import { RouterErrorBoundary } from "./RouterErrorBoundary/RouterErrorBoundary"

export const AdminRoutes: RouteObject = {
  path: ADMIN_PATH,
  errorElement: <UnauthorizedPage />,
  children: [
    {
      path: "add-permission",
      element: <AddPermissionPage />,
      errorElement: <RouterErrorBoundary />
    }
  ]
}
